export default "__VITE_ASSET__DGQKTXcc__"